import {
    bankMovements,
    create,
    deleteItem,
    disconnectAutomaticItem,
    getAll,
    getFinancialEntitys,
    updatePartial,
} from "@/api/financialEntity";

export default {
    state: {
        isActFinanceAcc: false,
        financialEntityAccList: [],
        lastUpdate: null,
        financialEntityList: [],
        bankMovements: [],
        numberRegisters: 0,
        loadingMovements: false,
        tableDataParams: {
            page: 1,
        },
        hasAutomaticAccounts: false,
        modalData: {
            description: {},
            owner_account_name: "",
            amount: 0,
        },
        isDownloadMovements: false,
        detailOpenList: [],
    },
    mutations: {
        SET_DETAILS_OPEN_LIST: (state, payload) => {
            state.detailOpenList = payload;
        },
        SET_IS_DOWNLOAD_MOVEMENTS: (state, payload) => {
            state.isDownloadMovements = payload;
        },
        SET_IS_ACT_FINANCE_ACC: (state, payload) => {
            state.isActFinanceAcc = payload;
        },
        SET_FINANCE_ACCOUNT_LIST: (state, payload) => {
            state.financialEntityAccList = payload;
        },
        SET_FINANCE_ENTITIES_LIST: (state, payload) => {
            state.financialEntityList = payload;
        },
        SET_BANK_STAMENT_LIST: (state, payload) => {
            state.bankMovements = payload;
        },
        SET_TABLE_DATA_PARAMS: (state, payload) => {
            state.tableDataParams = payload;
        },
        SET_TABLE_DATA_LOADING: (state, payload) => {
            state.loadingMovements = payload;
        },
        SET_NUMBER_REGISTERS: (state, payload) => {
            state.numberRegisters = payload;
        },
        SET_LAST_UPDATE: (state, payload) => {
            state.lastUpdate = payload;
        },
        SET_HAS_AUTOMATIC_ACCOUNTS: (state, payload) => {
            state.hasAutomaticAccounts = payload;
        },
        CREATE_FINANCE_ACCOUNT: (state, payload) => {
            state.lastUpdate = payload.updated_at;
            state.financialEntityAccList.unshift(payload);
        },
        UPDATE_FINANCE_ACCOUNT: (state, payload) => {
            state.financialEntityAccList = state.financialEntityAccList.filter(
                (item) => {
                    item.is_password_changed = false
                    if (item.id === payload.id) {
                        if (payload.field.amount) {
                            item.amount = payload.field.amount;
                            item.updated_at = new Date();
                            state.lastUpdate = new Date();
                        }
                        if (
                            payload.field.is_automatic === true ||
                            payload.field.is_automatic === false
                        ) {
                            item.is_automatic = payload.field.is_automatic;
                        }
                        item.is_password_changed = payload.field.is_password_changed;
                    }
                    return item;
                }
            );
        },
        DEL_FINANCE_ACCOUNT: (state, id) => {
            state.financialEntityAccList = state.financialEntityAccList.filter(
                (item) => item.id !== id
            );
        },
        SET_MODAL_DATA: (state, payload) => {
            state.modalData = payload;
        },
    },
    actions: {
        getFinanceEntitys({ commit, dispatch }) {
            getAll().then((response) => {
                let data = response.data;
                let lastUpdate = null;
                if (data.length > 0)
                    lastUpdate = data
                        .filter((item) => !item.is_automatic)
                        .reverse();
                if (
                    typeof lastUpdate !== "undefined" &&
                    lastUpdate !== null &&
                    lastUpdate.length > 0
                )
                commit("SET_LAST_UPDATE", lastUpdate[0].updated_at);
                commit("SET_FINANCE_ACCOUNT_LIST", data.reverse());
                dispatch("checkForAutomaticAccounts");
                // TODO: Move getFinancialEntitys to their own individual action
                getFinancialEntitys().then((response) => {
                    commit("SET_FINANCE_ENTITIES_LIST", response.data);
                });
            });
        },
        getBankMovements({ commit, state, dispatch }) {
            commit("SET_TABLE_DATA_LOADING", true);
            return new Promise((resolve, reject) => {
                bankMovements({ params: state.tableDataParams })
                    .then((response) => {
                        const data = response.data;
                        commit("SET_BANK_STAMENT_LIST", data.results);
                        commit("SET_NUMBER_REGISTERS", data.count);
                        dispatch("checkForAutomaticAccounts");
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        commit("SET_TABLE_DATA_LOADING", false);
                    });
            });
        },
        createFinanceEntity({ commit, state }, data) {
            if (typeof data.amount === "string") {
                data.amount = data.amount.replace("$ ", "").replace(/\./g, "");
            }
            return new Promise((resolve, reject) => {
                create(data)
                    .then((response) => {
                        response.data.financial_entity = {
                            name: state.financialEntityList.find(
                                (item) => item.id === data.financial_entity
                            ).name,
                        };
                        commit("CREATE_FINANCE_ACCOUNT", response.data);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updateFinanceEntity({ commit }, data) {
            return new Promise((resolve, reject) => {
                updatePartial(data)
                    .then(() => {
                        commit("UPDATE_FINANCE_ACCOUNT", data);
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteFinanceEntity({ commit }, id) {
            return new Promise((resolve, reject) => {
                deleteItem(id)
                    .then(() => {
                        commit("DEL_FINANCE_ACCOUNT", id);
                        resolve(id);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        checkForAutomaticAccounts({ commit, state }) {
            const hasAutomaticItems = state.financialEntityAccList.some(
                (item) => item.is_automatic
            );
            commit("SET_HAS_AUTOMATIC_ACCOUNTS", hasAutomaticItems);
        },
        // eslint-disable-next-line no-unused-vars
        disconnectFinanceEntity({ commit }, id) {
            return new Promise((resolve, reject) => {
                disconnectAutomaticItem(id)
                    .then(() => {
                        resolve(id);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
    getters: {
        totalFinanceAccounts: (state) => {
            let totals = [];
            state.financialEntityAccList.forEach((element) => {
                let amount = element.amount;
                amount =
                    typeof amount === "string"
                        ? parseInt(amount.replace("$ ", "").replace(/\./g, ""))
                        : amount;
                totals.push(amount);
            });
            return totals.reduce((acc, amount) => acc + amount, 0);
        },
    },
    namespaced: true,
};
